import type { FC } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { InfoPopover } from "../dynamicForm/inlineForm/InfoPopover";
import { useHoverPopover } from "../shared/HoverPopover";
import { multilineEllipsis } from "../shared/multilineEllipsis";

type ColumnHeaderProps = {
  headerText: string;
  popoverHeader?: string;
  popoverBody?: string;
  popoverExtraHelpInformation?: string;
};
export const ColumnHeader: FC<ColumnHeaderProps> = ({
  headerText,
  popoverHeader,
  popoverBody,
  popoverExtraHelpInformation,
}) => {
  const { popoverProps, anchorProps } = useHoverPopover();

  const showPopover = popoverHeader || popoverBody || popoverExtraHelpInformation;

  return (
    <Stack spacing={1} direction="row" sx={{ alignItems: "center", pr: 2 }}>
      <Typography
        {...(showPopover ? anchorProps : undefined)}
        variant="body2"
        sx={[
          {
            fontWeight: "600",
          },
          multilineEllipsis(2),
        ]}
      >
        {headerText}
      </Typography>
      {showPopover && (
        <InfoPopover {...popoverProps} title={popoverHeader} body={popoverBody} info={popoverExtraHelpInformation} />
      )}
    </Stack>
  );
};
